

import React, { memo } from 'react';
import globalConfig from 'react-global-configuration';
import { Divider } from '../../../ui-kit';
import { SocialAuthButtonList } from '../../SocialAuth';









const AuthButtons = ({
  submitBtn,
  hasSocial = true,
  hasSubmitBtn = true,
  socialProps
}) => {
  const HIDE_FEATURES = globalConfig.get('HIDE_FEATURES') || {};
  const hasSocialComponent = hasSocial && !HIDE_FEATURES.LOGIN_SOCIAL;
  const hasSubmitBtnComponent = hasSubmitBtn && submitBtn;
  const hasDivider = hasSocialComponent && hasSubmitBtnComponent;

  return (
    <>
      {hasSubmitBtnComponent && submitBtn}

      {hasDivider && <Divider isFullWidth>or</Divider>}

      {
      hasSocialComponent &&
      <SocialAuthButtonList {...socialProps} />}

    </>);

};


export default memo(AuthButtons);